import { Container, Point, Sprite, TextStyle, Texture } from "pixi.js";
import { UIButtonBase } from "../../../../../common/components/UIButtonBase";
import { AdaptiveText } from "ui-pixijs";
import { CommonResourcesPackage } from "../../../../../common/resources/CommonResourcesPackage";
import { WeaponType } from "../../../models/data/WeaponType";
import { GameFont } from "../../../../../common/GameFont";

export class WeaponButton extends UIButtonBase {
    protected readonly icon: Sprite;
    protected readonly countSubstrate: Sprite;
    protected readonly selection: Sprite;
    protected readonly countText: AdaptiveText;

    public get count(): number {
        return this.ammo;
    }

    public set count(value: number) {
        this.ammo = value;
        this.countText.text = this.ammo === -1 ? "∞" : this.ammo;
        this.countText.position.set((this.countSubstrate.width - this.countText.width) * 0.5, (this.countSubstrate.height - this.countText.height) * 0.5 - 7);
        this.enabled = this.ammo === -1 || this.ammo > 0;
    }

    public get flyTargetCoordinates(): Point {
        const icon = this.icon;
        const gv = this.parent.parent.parent as Container;
        const lb = icon.getLocalBounds();
        const localCenter = new Point(lb.x + lb.width / 2, lb.y + lb.height / 2);

        return gv ? gv.toLocal(localCenter, icon) : localCenter; // Convert from icon's local space to GameView's local space
    }

    public set selected(value: boolean) {
        this.selection.visible = value;
    }

    public get width(): number {
        return 205;
    }

    public get height(): number {
        return 200;
    }

    public get countSubstratePosition() {
        return this.countSubstrate.position;
    }

    public set countSubstratePosition(value: Point) {
        this.countSubstrate.position.set(value.x, value.y);
    }

    public constructor(
        commonResources: CommonResourcesPackage,
        public readonly type: WeaponType,
        protected ammo: number = -1,
        selected: boolean = false
    ) {
        super({ defaultTexture: commonResources.assets_common_boosters_booster_substrate_png });
        this.icon = new Sprite(commonResources[this.getWeaponTextureKey(type)] as Texture);
        this.icon.position.set((this.defaultView.width - this.icon.width) * 0.5, (this.defaultView.height - this.icon.height) * 0.5);
        this.defaultView.addChild(this.icon);

        this.countSubstrate = new Sprite(commonResources.assets_common_boosters_counter_substrate_png);
        this.selection = new Sprite(commonResources.assets_common_weapons_selected_png);
        this.selection.position.set(-3);
        this.selection.visible = selected;
        this.countText = new AdaptiveText(ammo === -1 ? "∞" : ammo.toString(), new CountTextStyle(), 36, 40);
        this.countSubstrate.addChild(this.countText);
        this.countText.updateText(false);
        this.countText.position.set((this.countSubstrate.width - this.countText.width) * 0.5, (this.countSubstrate.height - this.countText.height) * 0.5 - 7);
        this.countSubstrate.position.set(130, 130);
        this.enabled = ammo === -1 || ammo > 0;
        this.addChild(this.selection, this.countSubstrate);
    }

    private getWeaponTextureKey(weapon: WeaponType): keyof CommonResourcesPackage {
        let weaponName: string;
        switch(weapon) {
            case WeaponType.Rock: {
                weaponName = "rock";
                break;
            }
            case WeaponType.Boomerang: {
                weaponName = "boomerang";
                break;
            }
            case WeaponType.Dynamite: {
                weaponName = "dynamite";
                break;
            }
            default: {
                throw new Error(`WeaponButton.getWeaponTextureKey unhandled weapon type=${weapon}`);
            }
        }
        return `assets_common_weapons_${weaponName}_png` as keyof CommonResourcesPackage;
    }
}

export class CountTextStyle extends TextStyle {
    public constructor() {
        super({
            fontSize: 26,
            fill: "#6023BD",
            fontFamily: GameFont.Default,
        })
    }
}
